<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Tên vị trí
        </label>
        <b-input v-model="entry.position" type="text" placeholder="Nhập tên vị trí..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            position: "",
        },
    }),
    watch: {
        "entry.position": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    position: this.entry.position,
                });
            },
            deep: true,
        },
        "value.position": {
            handler: function () {
                this.entry.position = this.value.position;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>